import React from "react";

export default function FilterSection({
  filters,
  onFilterChange,
  onApply,
  onClear,
}) {
  return (
    <div className="bg-gray-50 p-3 sm:p-4 rounded-lg mb-4">
      <h4 className="text-sm sm:text-md font-medium mb-3">Filter Results</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4">
        <div>
          <label className="block text-xs sm:text-sm font-medium mb-1">
            Search
          </label>
          <input
            type="text"
            placeholder="Search..."
            value={filters.search}
            onChange={(e) =>
              onFilterChange({ ...filters, search: e.target.value })
            }
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium mb-1">
            Status
          </label>
          <select
            value={filters.status}
            onChange={(e) =>
              onFilterChange({ ...filters, status: e.target.value })
            }
            className="w-full border rounded px-3 py-2 text-sm"
          >
            <option value="">All Status</option>
            <option value="Success">Success</option>
            <option value="Failed">Failed</option>
            <option value="Pending">Pending</option>
          </select>
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium mb-1">
            From Date
          </label>
          <input
            type="date"
            value={filters.fromDate}
            onChange={(e) =>
              onFilterChange({ ...filters, fromDate: e.target.value })
            }
            className="w-full border rounded px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium mb-1">
            To Date
          </label>
          <input
            type="date"
            value={filters.toDate}
            onChange={(e) =>
              onFilterChange({ ...filters, toDate: e.target.value })
            }
            className="w-full border rounded px-3 py-2 text-sm"
          />
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-end gap-2">
        <button
          onClick={onClear}
          className="w-full sm:w-auto px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm"
        >
          Clear
        </button>
        <button
          onClick={onApply}
          className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
        >
          Apply
        </button>
      </div>
    </div>
  );
}
